var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgDropboxBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 160,
    viewBox: "0 0 270 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4824_194905",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 270,
    height: 160
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 270,
    height: 160,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4824_194905)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M300.657 5.12796L297.363 4.72578C238.426 -2.45649 186.69 21.8216 155.788 71.1818C128.5 114.779 84.7858 139.031 33.8176 138.869L-25.4783 138.677L59.7463 294.938L367 125.5L300.657 5.12796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M311.194 25.1553L307.9 24.7531C248.95 17.5647 197.215 41.8427 166.32 91.1991C139.031 134.797 95.3172 159.048 44.3491 158.886L-14.9417 158.704L76 302L383.254 132.562L311.194 25.1553Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M321.731 45.1831L318.437 44.781C259.487 37.5925 207.752 61.8706 176.857 111.227C149.568 154.824 105.854 179.076 54.8861 178.914L-4.4046 178.732L75.5 288.5L382.754 119.062L321.731 45.1831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M333.321 67.2134L330.028 66.8113C271.077 59.6228 219.342 83.9009 188.447 133.257C161.159 176.855 117.445 201.106 66.4765 200.944L7.18579 200.762L72.7463 285.938L380 116.5L333.321 67.2134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M343.332 86.2395L340.038 85.8374C281.087 78.6489 229.352 102.927 198.457 152.283C171.169 195.881 127.455 220.133 76.4866 219.97L17.1959 219.788L51.3248 284.658L358.578 115.219L343.332 86.2395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M352.288 103.263L348.994 102.861C290.043 95.6721 238.308 119.95 207.413 169.307C180.125 212.904 136.411 237.156 85.4429 236.993L26.1522 236.812L60.281 301.681L367.535 132.243L352.288 103.263Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgDropboxBg);
export default __webpack_public_path__ + "static/media/img-dropbox-bg.6ba2c2ca8a6b9fcae659ba52c9b040a7.svg";
export { ForwardRef as ReactComponent };